// extracted by mini-css-extract-plugin
export default {"header":"Task_header__2ao0y","singleCharAnswer":"Task_singleCharAnswer__10Qsm","pulseShadow":"Task_pulseShadow__0UyOv","blinkUnderscore":"Task_blinkUnderscore__UoZqa"};